import { HasId } from '../common/model/traits';
import { SocketMessageEvent } from '../sockets/messages';
import { ApiRoute, HttpMethod } from '../common/api/routes';

export type BannerNotificationType = 'error' | 'info' | 'success' | 'warning';

export interface BannerNotification extends HasId {
    message: string;
    type: BannerNotificationType;
    dismissable: boolean;
}

export interface BannerNotificationCreateDto {
    message: string;
    type: BannerNotificationType;
    dismissable: boolean;
}

export interface BannerNotificationSocketData {
    notification: BannerNotification | null;
}

export const bannerNotificationSocketEvent = new SocketMessageEvent<BannerNotificationSocketData>('banner.notify');

export const BannerNotificationApi = {
    createBannerNotification: new ApiRoute<BannerNotification, void, BannerNotificationCreateDto, void>(
        HttpMethod.Post,
        path => path.literal('bannerNotifications'),
    ),
    deleteCurrentBannerNotification: new ApiRoute<void, void, void, void>(HttpMethod.Delete, path =>
        path.literal('bannerNotifications'),
    ),
    getCurrentBannerNotification: new ApiRoute<BannerNotification, void, void, void>(HttpMethod.Get, path =>
        path.literal('bannerNotifications'),
    ),
};
